import { api } from '../../AxiosConfig';

class VendasService {
    create(data: any) {
        return api.post('/vendas/create', data);
    }

    findAll(params?: any) {
        return api.get('/vendas/findAll', { params });
    }

    getById(id: string) {
        return api.get(`/vendas/get/${id}`);
    }

    remove(id: string) {
        return api.post('/vendas/delete', { id });
    }

    createRecorrente(data: any) {
        return api.post('/vendas/recorrentes/create', data);
    }

    findRecorrentes(params?: any) {
        return api.get('/vendas/recorrentes/findAll', { params });
    }

    createByRecorrente(id: string) {
        return api.post('/vendas/recorrentes/create-sale', { id });
    }

    updateRecorrenteStatus(id: string, status: string) {
        return api.post('/vendas/recorrentes/update-status', { id, status });
    }
}

export { VendasService };
